export const chapters: Record<number, { id: number; comicId: number; number: number; title: string; updateTime: string }[]> = {
  1: [
    { id: 101, comicId: 1, number: 1, title: '第1话 化妆的力量', updateTime: '2024-03-15' },
    { id: 102, comicId: 1, number: 2, title: '第2话 转学生的秘密', updateTime: '2024-03-22' },
    { id: 103, comicId: 1, number: 3, title: '第3话 校园里的目光', updateTime: '2024-03-29' },
    { id: 104, comicId: 1, number: 4, title: '第4话 意外的相遇', updateTime: '2024-04-05' },
    { id: 105, comicId: 1, number: 5, title: '第5话 藏在心底的话', updateTime: '2024-04-12' },
    { id: 106, comicId: 1, number: 6, title: '第6话 图书馆事件', updateTime: '2024-04-19' },
    { id: 107, comicId: 1, number: 7, title: '第7话 他的过去', updateTime: '2024-04-26' },
    { id: 108, comicId: 1, number: 8, title: '第8话 化装舞会', updateTime: '2024-05-03' },
    { id: 109, comicId: 1, number: 9, title: '第9话 真心的告白', updateTime: '2024-05-10' },
    { id: 110, comicId: 1, number: 10, title: '第10话 新学期开始', updateTime: '2024-05-17' },
    { id: 111, comicId: 1, number: 11, title: '第11话 新的危机', updateTime: '2024-05-24' },
    { id: 112, comicId: 1, number: 12, title: '第12话 友情的考验', updateTime: '2024-06-01' },
  ],
  2: [
    { id: 201, comicId: 2, number: 1, title: '第1话 E级猎人', updateTime: '2023-01-10' },
    { id: 202, comicId: 2, number: 2, title: '第2话 双重地下城', updateTime: '2023-01-17' },
    { id: 203, comicId: 2, number: 3, title: '第3话 觉醒', updateTime: '2023-01-24' },
    { id: 204, comicId: 2, number: 4, title: '第4话 系统', updateTime: '2023-01-31' },
    { id: 205, comicId: 2, number: 5, title: '第5话 日常任务', updateTime: '2023-02-07' },
    { id: 206, comicId: 2, number: 6, title: '第6话 首次地下城', updateTime: '2023-02-14' },
    { id: 207, comicId: 2, number: 7, title: '第7话 杀手锏', updateTime: '2023-02-21' },
    { id: 208, comicId: 2, number: 8, title: '第8话 转职', updateTime: '2023-02-28' },
    { id: 209, comicId: 2, number: 9, title: '第9话 暗影君主', updateTime: '2023-03-07' },
    { id: 210, comicId: 2, number: 10, title: '第10话 S级之门', updateTime: '2023-03-14' },
  ],
  3: [
    { id: 301, comicId: 3, number: 1, title: '第1话 皇后的决断', updateTime: '2024-11-01' },
    { id: 302, comicId: 3, number: 2, title: '第2话 离婚申请书', updateTime: '2024-11-08' },
    { id: 303, comicId: 3, number: 3, title: '第3话 新的婚姻', updateTime: '2024-11-15' },
    { id: 304, comicId: 3, number: 4, title: '第4话 公爵的领地', updateTime: '2024-11-22' },
    { id: 305, comicId: 3, number: 5, title: '第5话 宫廷阴谋', updateTime: '2024-11-29' },
    { id: 306, comicId: 3, number: 6, title: '第6话 反击', updateTime: '2024-12-06' },
    { id: 307, comicId: 3, number: 7, title: '第7话 皇帝后悔', updateTime: '2024-12-13' },
    { id: 308, comicId: 3, number: 8, title: '第8话 双后对峙', updateTime: '2024-12-20' },
  ],
  4: [
    { id: 401, comicId: 4, number: 1, title: '第1话 完美策展人', updateTime: '2023-06-01' },
    { id: 402, comicId: 4, number: 2, title: '第2话 站姐的秘密', updateTime: '2023-06-08' },
    { id: 403, comicId: 4, number: 3, title: '第3话 新馆长的挑衅', updateTime: '2023-06-15' },
    { id: 404, comicId: 4, number: 4, title: '第4话 意外暴露', updateTime: '2023-06-22' },
    { id: 405, comicId: 4, number: 5, title: '第5话 他的条件', updateTime: '2023-06-29' },
    { id: 406, comicId: 4, number: 6, title: '第6话 假装恋爱', updateTime: '2023-07-06' },
  ],
  5: [
    { id: 501, comicId: 5, number: 1, title: '第1话 那天的公寓', updateTime: '2022-09-10' },
    { id: 502, comicId: 5, number: 2, title: '第2话 怪物出现', updateTime: '2022-09-17' },
    { id: 503, comicId: 5, number: 3, title: '第3话 封锁', updateTime: '2022-09-24' },
    { id: 504, comicId: 5, number: 4, title: '第4话 邻居们', updateTime: '2022-10-01' },
    { id: 505, comicId: 5, number: 5, title: '第5话 求生法则', updateTime: '2022-10-08' },
    { id: 506, comicId: 5, number: 6, title: '第6话 感染', updateTime: '2022-10-15' },
    { id: 507, comicId: 5, number: 7, title: '第7话 抉择', updateTime: '2022-10-22' },
    { id: 508, comicId: 5, number: 8, title: '第8话 希望之光', updateTime: '2022-10-29' },
  ],
  6: [
    { id: 601, comicId: 6, number: 1, title: '第1话 结局已知的人', updateTime: '2024-01-05' },
    { id: 602, comicId: 6, number: 2, title: '第2话 主角登场', updateTime: '2024-01-12' },
    { id: 603, comicId: 6, number: 3, title: '第3话 第一个场景', updateTime: '2024-01-19' },
    { id: 604, comicId: 6, number: 4, title: '第4话 改变命运', updateTime: '2024-01-26' },
    { id: 605, comicId: 6, number: 5, title: '第5话 星座的注视', updateTime: '2024-02-02' },
    { id: 606, comicId: 6, number: 6, title: '第6话 赞助者', updateTime: '2024-02-09' },
    { id: 607, comicId: 6, number: 7, title: '第7话 首次死亡', updateTime: '2024-02-16' },
    { id: 608, comicId: 6, number: 8, title: '第8话 回归', updateTime: '2024-02-23' },
  ],
  7: [
    { id: 701, comicId: 7, number: 1, title: '第1话 穿越成公主', updateTime: '2024-05-01' },
    { id: 702, comicId: 7, number: 2, title: '第2话 冷酷父皇', updateTime: '2024-05-08' },
    { id: 703, comicId: 7, number: 3, title: '第3话 讨好计划', updateTime: '2024-05-15' },
    { id: 704, comicId: 7, number: 4, title: '第4话 第一次微笑', updateTime: '2024-05-22' },
    { id: 705, comicId: 7, number: 5, title: '第5话 花园奇遇', updateTime: '2024-05-29' },
    { id: 706, comicId: 7, number: 6, title: '第6话 魔法师', updateTime: '2024-06-05' },
  ],
  8: [
    { id: 801, comicId: 8, number: 1, title: '第1话 完美秘书', updateTime: '2023-03-10' },
    { id: 802, comicId: 8, number: 2, title: '第2话 辞呈', updateTime: '2023-03-17' },
    { id: 803, comicId: 8, number: 3, title: '第3话 副会长的震惊', updateTime: '2023-03-24' },
    { id: 804, comicId: 8, number: 4, title: '第4话 挽留', updateTime: '2023-03-31' },
    { id: 805, comicId: 8, number: 5, title: '第5话 约会提案', updateTime: '2023-04-07' },
  ],
  9: [
    { id: 901, comicId: 9, number: 1, title: '第1话 退学', updateTime: '2022-05-10' },
    { id: 902, comicId: 9, number: 2, title: '第2话 父亲', updateTime: '2022-05-17' },
    { id: 903, comicId: 9, number: 3, title: '第3话 梨泰院', updateTime: '2022-05-24' },
    { id: 904, comicId: 9, number: 4, title: '第4话 甜夜开业', updateTime: '2022-06-01' },
    { id: 905, comicId: 9, number: 5, title: '第5话 复仇之路', updateTime: '2022-06-08' },
    { id: 906, comicId: 9, number: 6, title: '第6话 对决', updateTime: '2022-06-15' },
  ],
  10: [
    { id: 1001, comicId: 10, number: 1, title: '第1话 替身相亲', updateTime: '2023-08-01' },
    { id: 1002, comicId: 10, number: 2, title: '第2话 CEO的真面目', updateTime: '2023-08-08' },
    { id: 1003, comicId: 10, number: 3, title: '第3话 第二次见面', updateTime: '2023-08-15' },
    { id: 1004, comicId: 10, number: 4, title: '第4话 合约恋爱', updateTime: '2023-08-22' },
    { id: 1005, comicId: 10, number: 5, title: '第5话 公司里的目光', updateTime: '2023-08-29' },
    { id: 1006, comicId: 10, number: 6, title: '第6话 真心', updateTime: '2023-09-05' },
  ],
  11: [
    { id: 1101, comicId: 11, number: 1, title: '第1话 塔的召唤', updateTime: '2022-01-10' },
    { id: 1102, comicId: 11, number: 2, title: '第2话 第一层考验', updateTime: '2022-01-17' },
    { id: 1103, comicId: 11, number: 3, title: '第3话 伙伴', updateTime: '2022-01-24' },
    { id: 1104, comicId: 11, number: 4, title: '第4话 王冠游戏', updateTime: '2022-01-31' },
    { id: 1105, comicId: 11, number: 5, title: '第5话 坤的家世', updateTime: '2022-02-07' },
  ],
  12: [
    { id: 1201, comicId: 12, number: 1, title: '第1话 平凡的我', updateTime: '2024-02-10' },
    { id: 1202, comicId: 12, number: 2, title: '第2话 三个美女', updateTime: '2024-02-17' },
    { id: 1203, comicId: 12, number: 3, title: '第3话 格格不入', updateTime: '2024-02-24' },
    { id: 1204, comicId: 12, number: 4, title: '第4话 友谊的开始', updateTime: '2024-03-02' },
  ],
};

export const getChaptersByComicId = (comicId: number) => chapters[comicId] || [];